import { render, staticRenderFns } from "./simple_filter.vue?vue&type=template&id=5136b7bb&"
import script from "./simple_filter.vue?vue&type=script&lang=js&"
export * from "./simple_filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports